import React from "react";

export default function WriterGuidelinesHero() {
  return (
    <section className="w-full bg-[#F0E9FD] overflow-hidden">
      <div className="max-w-7xl mx-auto  flex flex-col md:flex-row items-center gap-10 md:gap-16 ">
        <div className="w-full md:w-[420px] shrink-0">
          <img
            src="/img/dashboard/writer-guidelines-hero.svg"
            alt="Blog writer guidelines"
            className="w-full h-auto object-contain"
          />
        </div>

        <div className="flex-1 text-center">
          <h1 className="font-semibold text-3xl sm:text-4xl md:text-[42px] leading-tight mb-4">
            <span className="text-slate-900 font-normal">Blog Writer </span>
            <span className="text-[#7209B7]">Guidelines</span>
          </h1>
          <p className="text-slate-600 text-sm sm:text-[16px] text-center max-w-2xl mx-auto">
            Write authentic travel stories, useful tips, and experiences
            that help other solo travelers explore with confidence.
          </p>
        </div>
      </div>
    </section>
  );
}
